import FormCreate from './core/index';


const maker = FormCreate.maker;

export {maker}

export default FormCreate;
